import React       from 'react';
import ReactPlayer from 'react-player';

function renderYoutubeVideoBlock(data, index) {
  const {
          AUTOPLAY,
          BACKGROUND_COLOR,
          CONTENT,
          LOOP,
          MUTED,
        } = data;

  return (
    <section key={index} style={{ backgroundColor: BACKGROUND_COLOR }}>
      <div className={'container'}>
        <ReactPlayer
          className={'video'}
          config={{
            youtube: {
              playerVars: {
                autoplay: AUTOPLAY ? 1 : 0,
                controls: 1,
                loop:     LOOP ? 1 : 0,
                showinfo: 0,
              },
            },
          }}
          controls={true}
          loop={LOOP}
          muted={MUTED}
          url={CONTENT?.replace('/shorts/', '/embed/')}
        />
      </div>
    </section>
  );
}

export default renderYoutubeVideoBlock;